// Pushes keydown events to LiveView, but only when the user isn't typing in
// an input/textarea/select. Replaces phx-window-keydown which has a race
// condition: the window-level keydown arrives at the server before phx-focus
// can round-trip, so server-side focus tracking can't reliably gate shortcuts.
// Checking document.activeElement here is synchronous and always correct.
//
// Allowed keys are read from the `data-keys` attribute on the hook element
// (space-separated). Escape is always allowed.

const INPUT_TAGS = new Set(["INPUT", "TEXTAREA", "SELECT"]);

export const KeyboardShortcuts = {
  mounted() {
    this._allowedKeys = this._parseKeys();

    this._handler = (e) => {
      const inInput =
        INPUT_TAGS.has(document.activeElement?.tagName) ||
        document.activeElement?.isContentEditable;

      if (inInput && e.key !== "Escape") return;
      if (!this._allowedKeys.has(e.key)) return;

      this.pushEvent("keydown", { key: e.key });
    };

    window.addEventListener("keydown", this._handler);
  },

  updated() {
    this._allowedKeys = this._parseKeys();
  },

  destroyed() {
    window.removeEventListener("keydown", this._handler);
  },

  _parseKeys() {
    const raw = this.el.dataset.keys || "";
    const keys = new Set(raw.split(" ").filter(Boolean));
    keys.add("Escape");
    return keys;
  },
};
